import Vue from "vue";
import moment from "moment";
Vue.filter("formatDate", (value: string) => value ? moment(value).format("MM/DD/YYYY") : "");
